import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import Grid from "@mui/material/Grid2";

const sections = [
  {
    title: "Fetcher Configs",
    current: [
      { name: "IA_QCK_After_day", count: 19 },
      { name: "IA_QCK_none", count: 22 },
      { name: "IA_earning_month", count: 7 },
    ],
    removed: [{ name: "IA_acid_none_day", count: 21 }],
  },
  {
    title: "Unifier Maps",
    current: [
      { name: "ia_user_per_day_default_no_purchases", count: 13 },
      {
        name: "ia_brand_per_day_before_TotalBets/Hands_no_Deposits",
        count: 87,
      },
    ],
    removed: [],
  },
  {
    title: "Advisor Maps",
    current: [
      { name: "ia_daily_brand_performance_1", count: 14 },
      { name: "ia_daily_user_performance", count: 19 },
      {
        name: "ia_user_per_day_default_no_purchases",
        count: 18,
      },
    ],
    removed: [
      { name: "ia_user_per_day_default_no_rs", count: 2 },
      {
        name: "ia_user_per_day_default_no_net_revenue",
        count: 44,
      },
    ],
  },
];

type ConfigItem = {
  name: string;
  count: number;
};

type ConfigListProps = {
  items: ConfigItem[];
};

const ConfigList = ({ items }: ConfigListProps) => (
  <Box sx={{ mt: 2 }}>
    {items.map((item, index) => (
      <Typography
        key={`${item.name}-${index}`}
        sx={{
          fontSize: 14,
          mb: 1.5,
          color: "#000000DE",
          wordBreak: "break-word",
        }}
      >
        {item.name}{" "}
        <Box
          component="span"
          sx={{
            color: "#00000061",
          }}
        >
          ({item.count})
        </Box>
      </Typography>
    ))}
  </Box>
);

const ConfigSection = ({
  title,
  current,
  removed,
}: {
  title: string;
  current: ConfigItem[];
  removed: ConfigItem[];
}) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 500,
          color: "#00000061",
          mb: 1,
        }}
      >
        {title}
      </Typography>

      <Grid container>
        {/* Current */}
        <Grid
          size={{ xs: 12, md: 6 }}
          sx={{
            pr: { md: 4 },
          }}
        >
          <Typography
            sx={{
              color: "#2E7D32",
              fontSize: 12,
            }}
          >
            Current
          </Typography>

          <ConfigList items={current} />
        </Grid>

        {/* Removed */}
        <Grid
          size={{ xs: 12, md: 6 }}
          sx={{
            pl: { md: 4 },
            position: "relative",
            borderLeft: {
              xs: "none",
              md: "1px solid #e0e0e0",
            },
            mt: { xs: 2, md: 0 },
          }}
        >
          <Typography
            sx={{
              color: "#D32F2F",
              fontSize: 12,
            }}
          >
            Removed
          </Typography>

          <ConfigList items={removed} />
        </Grid>
      </Grid>
    </Box>
  );
};

const SaveChangesModalBodyOne = () => {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          padding: "16px 24px 20px 24px",
        }}
      >
        {sections.map((section) => (
          <ConfigSection
            key={section.title}
            title={section.title}
            current={section.current}
            removed={section.removed}
          />
        ))}
      </Box>
    </>
  );
};

export default SaveChangesModalBodyOne;
